// extracted by mini-css-extract-plugin
export var infoRow = "_r3-2";
export var labelContainer = "_r3-0";
export var rightInfo = "_r3-1";